import {BrowserRouter, Route, Routes as _Routes, useLocation} from "react-router-dom";
import {Fomulario} from "../pages/formulario";
import {Certificado} from "../pages/certificado";
import {Privacidade} from "../pages/privacidade";

const PublicRoute = ({Page} : any) => {
       return (       
                <Page/>
           
    )
}

export const Routes = () => {
    return (
        <BrowserRouter>
            <_Routes>
                <Route  path="/" element={<PublicRoute Page={Fomulario}/>}/>
                <Route  path="/:id" element={<PublicRoute Page={Fomulario}/>}/>
                <Route  path="/certificado/:id" element={<PublicRoute Page={Certificado}/>}/>
                <Route  path="/politica-de-privacidade/" element={<PublicRoute Page={Privacidade}/>}/>
                <Route  path="/politica-de-privacidade/:id" element={<PublicRoute Page={Privacidade}/>}/>
            </_Routes>
        </BrowserRouter>

    )

}